import React from 'react'
import InputCustom from 'components/Inputs'
import { FiTrash } from 'react-icons/fi'
import { RiIncreaseDecreaseLine } from 'react-icons/ri'
import { Col, Collapse, Row } from 'reactstrap'
import { SimpleTitleCard } from 'styles/global'
import CardParametrizacao from './CardParametrizacao'
import { BiChevronDown } from 'react-icons/bi'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { PRODUTO } from 'store/modules/backoffice/produto/types'
import { ParametrizacaoProdutoReq } from 'models/backoffice/produto/type'
import * as produtoActions from 'store/modules/backoffice/produto/actions'
import useRedux from 'hooks/useRedux'
import { maskMoney } from 'util/masks'

const CardValorContrato = () => {
  const { register, visualizacao, cardsState, invalids } = useSelector<
    ApplicationState,
    PRODUTO
  >((state) => state.produto)

  const { dispatch } = useRedux()

  type Field = keyof ParametrizacaoProdutoReq

  function onChange(value: string | number, field: Field) {
    dispatch(produtoActions.setRegister({ ...register, [field]: value }))
  }

  function onToggle() {
    dispatch(
      produtoActions.toggleCard(!cardsState.valorContrato, 'valorContrato')
    )
  }

  return (
    <CardParametrizacao>
      <div className="d-flex justify-content-between">
        <SimpleTitleCard color="#000" colorIcon="#000">
          <RiIncreaseDecreaseLine className="icon" />
          Valor do contrato + troco
        </SimpleTitleCard>
        <BiChevronDown onClick={() => onToggle()} className="toggler" />
      </div>
      <Collapse isOpen={cardsState.valorContrato}>
        <div className="d-flex flex-column row-gap-10">
          <Row>
            <Col>
              <label className="info-card">
                Campo disponível apenas para a instituição BMG
              </label>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <label className="label-12">Valor (em R$)</label>
              <InputCustom
                type="text"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(maskMoney(e.target.value), 'valorContrato')
                }}
                value={register.valorContrato || ''}
                disabled={visualizacao}
                maxLength={14}
                invalid={invalids.valorContrato}
              />
            </Col>
          </Row>
          <div className="linha-horizontal"></div>
          {!visualizacao && (
            <Row>
              <Col className="d-flex justify-content-end">
                <FiTrash
                  onClick={() => dispatch(produtoActions.cleanValorContrato())}
                  className="icon-trash"
                />
              </Col>
            </Row>
          )}
        </div>
      </Collapse>
    </CardParametrizacao>
  )
}

export default CardValorContrato
